<template >
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>

    <h1>{{ $t("workflow.processCreate") }}</h1>

    <b-row>
      <b-col>
        <process-crud :model="model" :modelstate="modelstate"> </process-crud>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col>
        <b-button size="md" @click="createProcess" :disabled="submitted">
          {{ $t("workflow.processSave") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- {{ submitted }} -->
    <!-- <pre class="language-json"><code>model: {{ model  }}</code></pre> -->
    <!-- <pre class="language-json"><code>modelstate: {{ modelstate  }}</code></pre> -->
    <!-- {{ modelstate }} -->
    <!-- {{model}} -->
  </b-container>
</template>
<script>
export default {
  name: "ProcessCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    ProcessCrud: () =>
      import("@/components_rms/workflow/Process/ProcessCrud.vue"),
  },
  props: {
    idBase: String,
  },
  data: function () {
    return {
      submitted: false,
      alert: {
        error: "",
        success: "Processo criado com sucesso",
      },
      model: {
        displayName: "",
        active: true,
        fields: [],
        stages: [],
        scriptPosProcess: "",
        administrador: [],
        gestor: [],
        simpleOperator: [],
        advancedOperator: [],
      },
      modelstate: {},
    };
  },
  created() {
    if (this.idBase) this.cloneProcess();
  },
  mounted() {},
  methods: {
    createProcess() {
      console.log("create")
      console.log(this.model);
      this.submitted = true;
      this.$apiWorkflow
        .post("/process/Create", this.model)
        .then((response) => {
          console.log(response);
          this.submitted = false;
          this.$refs.alert.show();
          this.newModel();
        })
        .catch((error) => {
          this.submitted = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(error.response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    newModel() {
      this.model.displayName = "";
      this.model.active = true;
      this.model.fields = [];
      this.model.stages = [];
      this.model.scriptPosProcess = "";
      this.model.administrador = [];
      this.model.gestor = [];
      this.model.simpleOperator = [];
      this.model.advancedOperator = [];
    },
    cloneProcess() {
      this.$apiWorkflow
        .get("/process/clone/" + this.idBase)
        .then((response) => {
          this.model = response.data;
          console.log(this.model);
        });
    },
  },
};
</script>